import { Star, Globe, ShoppingCart, Search, Megaphone, Smartphone, MonitorSmartphone, LayoutTemplate, Code2, Store, Boxes, Briefcase, Wrench, Gauge, Target, Share2, Link2, Layers, Lightbulb, Headset, ShieldCheck, MousePointerClick, FileText, MessagesSquare, Package } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/Blocks";
import { TESTIMONIALS } from "@/data/testimonials";

const ICONS = { Star, Globe, ShoppingCart, Search, Megaphone, Smartphone, MonitorSmartphone, LayoutTemplate, Code2, Store, Boxes, Briefcase, Wrench, Gauge, Target, Share2, Link2, Layers, Lightbulb, Headset, ShieldCheck, MousePointerClick, FileText, MessagesSquare, Package };

export const Testimonials = () => (
  <section className="border-t border-stone bg-[#F1EEE7] py-24 lg:py-36" aria-labelledby="testimonials-heading" data-testid="testimonials-section">
    <div className="wrap">
      <SectionHead eyebrow="Client feedback" title="What Our Clients Say" lead="Feedback from businesses that discussed and planned websites, software, SEO and digital marketing with our team." />
    </div>
    <Reveal className="mt-14">
      <ul
        className="flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-6 sm:px-8 lg:px-[max(3rem,calc((100vw-1320px)/2+3rem))] [scrollbar-width:thin]"
        aria-label="Client testimonials"
        data-testid="testimonials-track"
      >
        {TESTIMONIALS.map((t) => {
          const Icon = ICONS[t.icon] ?? Star;
          return (
            <li key={t.name} className="flex w-[85%] shrink-0 snap-start sm:w-[380px]">
              <figure className="flex w-full flex-col rounded-md border border-stone bg-white p-7">
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-charcoal text-ivory" aria-hidden="true">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div className="flex gap-0.5 text-rust-deep" role="img" aria-label={`Rated ${t.rating} out of 5`}>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-current" aria-hidden="true" />
                    ))}
                  </div>
                </div>
                <blockquote className="mt-6 flex-1">
                  <p className="text-[15px] leading-relaxed text-graphite">{t.quote}</p>
                </blockquote>
                <figcaption className="mt-6 border-t border-stone pt-5">
                  <p className="font-display text-[17px] font-bold">{t.name}</p>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.16em] text-rust-ink">{t.service}</p>
                </figcaption>
              </figure>
            </li>
          );
        })}
      </ul>
    </Reveal>
  </section>
);
